<template>
  <div class="w-full flex-1 flex-col  lg:ml-base">
    <setting-surat></setting-surat>
    <show-surat></show-surat>
    <vx-card>
      <template slot="no-body">
        <!-- header -->
        <global-header :buttonBack="true" :actions="false">
          <template slot="actions-custom" v-if="!$apollo.queries.surat.loading">
            <vs-button
              @click="editSurat"
              type="border"
              color="success"
              icon-pack="feather"
              icon="icon-edit"
              v-if="surat.isUserCanEdit($user.id)"
              ><div class="hidden sm:block">Ubah</div></vs-button
            >
          </template>
        </global-header>

        <!-- Loading -->
        <div v-if="$apollo.queries.surat.loading">
          <global-skeleton :loadingType="'CardShow'"></global-skeleton>
        </div>

        <!-- Not data -->
        <div v-else-if="!surat">No data found</div>

        <!-- Load Surat -->
        <div v-else-if="!$apollo.queries.surat.loading && surat" class="w-full flex px-5">
          <!-- Info -->
          <div class="w-full">
            <div class="flex flex-col md:flex-row justify-center">
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Judul / Index</div>
                <div>
                  {{ surat.index }}
                </div>
              </div>
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Kode</div>
                <div class="">
                  <span v-if="surat.kode_surat">
                    {{ surat.kode_surat.kode_surat }} -
                    {{ surat.kode_surat.nama }}
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="flex flex-col mb-2 flex-1">
                <div class="font-bold">Tanggal Penyimpanan</div>
                <div>{{ surat.created_at | indonesian_date_time }}</div>
              </div>
              <div
                v-if="
                  surat.tipe == 'surat_masuk' && surat.surat_masuk.tipe != null
                "
                class="flex flex-col mb-2 flex-1"
              >
                <div class="font-bold">Tipe Surat</div>
                <div class="flex">
                  <vs-chip color="">
                    <vs-avatar icon-pack="feather" icon="icon-tag" />
                    {{ surat.surat_masuk.tipe }}
                  </vs-chip>
                </div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col ">
              <div class="flex flex-col mb-2">
                <div class="font-bold">Perihal</div>
                <div>
                  {{ surat.perihal }}
                </div>
              </div>
              <div class="flex flex-col mb-2">
                <div class="font-bold">Isi Ringkas</div>
                <div v-html="surat.isi_ringkas"></div>
              </div>
              <div class="flex flex-col mb-2">
                <div class="font-bold">Catatan</div>
                <div
                  v-if="surat.keterangan != null"
                  v-html="surat.keterangan"
                ></div>
                <div v-else>-</div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col">
              <div class="flex flex-col vx-row md:flex-row">
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="flex flex-col flex-1 mb-2 sm:mb-0">
                    <div class="font-bold ">
                      {{
                        surat.tipe == "surat_masuk" ? "Asal Surat" : "Tujuan"
                      }}
                    </div>
                    <div>
                      {{
                        surat.tipe == "surat_masuk"
                          ? surat.surat_masuk.pengirim
                          : surat.surat_keluar.tujuan
                      }}
                      <ul>
                        <li v-for="(item, index) in surat.tujuan" :key="index">
                          <vs-chip color="">
                            <vx-tooltip
                              v-if="item.email != null"
                              :text="item.email"
                              position="top"
                              >{{ item.nama }}</vx-tooltip
                            >
                            <span v-else>{{ item.nama }}</span>
                          </vs-chip>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold">Tanggal</div>
                  <div>{{ surat.tanggal | indonesian_date }}</div>
                </div>
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold">Nomor</div>
                  <div v-if="surat.nomor_surat">
                    {{ surat.nomor_surat.nomor }}
                  </div>
                  <div v-else class="text-danger">
                    Nomor Surat Belum Diambil
                  </div>
                  <div class="text-grey"></div>
                </div>
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold">Lampiran</div>
                  <div>{{ surat.lampiran }}</div>
                </div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col">
              <div class="flex flex-col vx-row md:flex-row">
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold mb-2">Kategori</div>
                  <div class="flex">
                    <vs-chip color="">
                      <vs-avatar icon-pack="feather" icon="icon-tag" color="" />
                      {{ surat.kategori_surat.nama }}
                    </vs-chip>
                  </div>
                </div>
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold mb-2">Kecepatan</div>
                  <div class="flex">
                    <vs-chip color="" v-if="surat.kecepatan_surat">
                      <vs-avatar
                        icon-pack="feather"
                        icon="icon-clock"
                        color=""
                      />
                      {{ surat.kecepatan_surat.nama }}
                    </vs-chip>
                  </div>
                </div>
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold mb-2">Sifat</div>
                  <div class="flex">
                    <vs-chip color="">
                      <vs-avatar
                        icon-pack="feather"
                        icon="icon-lock"
                        color=""
                      />
                      {{ surat.sifat_surat.nama }}
                    </vs-chip>
                  </div>
                </div>
                <div class="flex flex-col vx-col  flex-1 mb-2 md:mb-0">
                  <div class="font-bold mb-2">Status</div>
                  <div class="flex">
                    <StatusChip :status="surat.status" />
                  </div>
                </div>
              </div>
            </div>
            <vs-divider></vs-divider>
            <div class="flex flex-col">
              <div class="font-bold mb-2">Pencipta Surat</div>
              <div class="flex flex-col md:flex-row">
                <global-user
                  class="flex-1"
                  :name="surat.pengguna.nama"
                  :subname="surat.pengguna.jabatan.nama"
                >
                  <div class="text-grey text-sm flex items-center">
                    <feather-icon
                      icon="ClockIcon"
                      svgClasses="w-4 h-4 mr-2 "
                    ></feather-icon>
                    {{ surat.created_at | indonesian_date_time }}
                  </div>
                </global-user>
              </div>
              <vs-divider></vs-divider>
            </div>
            <div v-if="listParaf.length != 0" 
              class="flex flex-col"
            >
              <div class="font-bold mb-2">Paraf Persetujuan</div>
              <div class="flex flex-col md:flex-row" v-for="(item, index) in listParaf" :key="index">
                <global-user
                  class="flex-1"
                  :icon="item.paraf ? 'icon-check' : 'icon-x'"
                  :color="item.paraf ? 'success' : 'warning'"
                  :name="item.nama"
                  :subname="item.jabatan"
                >
                </global-user>
              </div>
              <vs-divider></vs-divider>
            </div>
            <div class="flex mt-5">
              <vs-tabs>
                <!-- More info and files -->
                <vs-tab
                  :label="`File ( ${surat.dokumen.length} )`"
                  icon-pack="feather"
                  icon="icon-file"
                >
                  <SuratFile
                    :surat="surat"
                    @submitCallback="refreshSuratQuery"
                  />
                </vs-tab>

                <!-- Disposition list -->
                <vs-tab
                  :label="`Disposisi ( ${surat.disposisi.length} )`"
                  icon-pack="feather"
                  icon="icon-activity"
                >
                  <SuratDisposisi :surat="surat" />
                </vs-tab>
              </vs-tabs>
            </div>
            <!-- Actions -->
            <div
              v-if="
                surat.isUserHasAction($user.id) &&
                  surat.isUserOnDisposition($user.id)
              "
              class="w-full my-5 shadow-md p-5 rounded-lg flex flex-col md:flex-row justify-between"
            >
              <div class="flex flex-col md:flex-row">
                <vs-button
                  v-if="surat.isUserCanDisposition($user.id)"
                  @click="$refs.dialogDisposisi.toggleActive(true)"
                  class="mr-2 mb-2"
                  color="primary"
                  icon="icon-arrow-up-right"
                  icon-pack="feather"
                >
                  Disposisi
                </vs-button>

                <vs-button
                  v-if="surat.isUserCanSend($user.id)"
                  class="mr-2 mb-2"
                  type="border"
                  color="primary"
                  icon="icon-send"
                  icon-pack="feather"
                  @click="confirmSendMail"
                >
                  Kirim Surat
                </vs-button>

                <vs-button
                  v-if="surat.isUserCanArchive($user.id)"
                  class="mr-2 mb-2"
                  type="border"
                  color="primary"
                  icon="icon-archive"
                  icon-pack="feather"
                  @click="confirmArchive"
                >
                  Arsipkan
                </vs-button>

                <vs-button
                  v-if="surat.isUserCanUnarchive($user.id)"
                  type="border"
                  class="mr-2 mb-2"
                  color="warning"
                  icon="icon-archive"
                  icon-pack="feather"
                  @click="confirmUnarchive"
                >
                  Batalkan Arsip
                </vs-button>

                <vs-button
                  class="mr-2 mb-2"
                  type="border"
                  color="warning"
                  icon="icon-dollar-sign"
                  icon-pack="feather"
                  v-if="surat.isUserCanGetNumber()"
                  @click="$refs.dialogNomorSurat.toggleActive(true)"
                >
                  Ambil Nomor
                </vs-button>

                <vs-button
                  class="mr-2 mb-2"
                  type="border"
                  color="warning"
                  icon="icon-calendar"
                  icon-pack="feather"
                  @click="handleAgenda"
                >
                  Agendakan
                </vs-button>
              </div>
              <div></div>
            </div>
          </div>
          <!-- Disposition -->
          <DialogDisposisi
            ref="dialogDisposisi"
            :surat="surat"
            @submitCallback="refreshSuratQuery"
          />

          <!-- Files -->

          <DialogNomorSurat
            ref="dialogNomorSurat"
            :suratUuid="surat.uuid"
            :suratId="surat.id"
            :kodeSurat="surat.kode_surat"
            @submitCallback="refreshSuratQuery"
          />
        </div>
      </template>
    </vx-card>
    <vs-button
      @click="$router.go(-1)"
      class="mt-base"
      icon-pack="feather"
      icon="icon-arrow-left"
      type="border"
      >Kembali</vs-button
    >
  </div>
</template>

<script>
import DialogDisposisi from "./components/detail/DialogDisposisi";
import DialogNomorSurat from "./components/detail/DialogNomorSurat";
import SuratDisposisi from "./components/detail/SuratDisposisi";
import SuratFile from "./components/detail/SuratFile";
import StatusChip from "./components/StatusChip.vue";
import StatusLabel from "./components/StatusLabel.vue";
import SettingSurat from "./components/setting-document/SettingDocument.vue";
import ShowSurat from "./components/lihat-surat/ShowDocument.vue";

import suratModifier from "@/modifiers/surat";
import disposisiModifier from "@/modifiers/disposisi";
import dokumenModifier from "@/modifiers/dokumen";

import { GET_BY_UUID, UPDATE } from "../../query/surat";
import { FIND } from "../../query/pengguna";

export default {
  components: {
    DialogDisposisi,
    DialogNomorSurat,
    SuratFile,
    SuratDisposisi,
    StatusChip,
    StatusLabel,
    SettingSurat,
    ShowSurat
  },

  data() {
    return {
      uuid: this.$route.params.uuid,
      settingSurat: false,
      surat: {},
      listParaf: []
    };
  },

  apollo: {
    surat: {
      query: GET_BY_UUID,
      variables() {
        return {
          uuid: this.uuid
        };
      },
      update(data) {
        this.setBodyTitle(data.surat.tipe);
        return this.getSuratModified(data.surat);
      },
      fetchPolicy: "cache-and-network"
    }
  },

  watch: {
    surat: {
      handler(){
        this.setListParafPersetujuan();
      }
    }
  },

  methods: {
    setBodyTitle(tipe) {
      const text =
        tipe == "surat_masuk" ? "Detail Surat Masuk" : "Detail Surat Keluar";

      this.$store.dispatch("globalApp/setHeaderTitle", text);
    },

    // Archive Action
    confirmArchive() {
      this.$root.confirmDialog({
        title: "Arsipkan surat ini ?",
        message: "Surat ini akan disimpan sebagai arsip",
        acceptTitle: "Arsipkan",
        cancelTitle: "Kembali",
        onAccept: this.handleOnArchive
      });
    },

    async handleOnArchive() {
      try {
        await this.archiveSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Arsip surat sukses"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Arsip surat gagal"
        });
      }
    },

    setListParafPersetujuan(){
      /* Get all paraf from user and sort it by disposisi id*/
      let listAllParaf = this.surat.disposisi.filter(item => item.paraf != null);
      listAllParaf.sort(function(a, b){ return b.id - a.id; });

      /* Filtering duplicate paraf identity by user_id and sort again by jabatan */
      let filteredParaf = Array.from(new Set(listAllParaf.map(s => s.pengguna.id))).map(id => {
        return {
          id: id,
          nama: listAllParaf.find(s => s.pengguna.id === id).pengguna.nama,
          paraf: listAllParaf.find(s => s.pengguna.id === id).paraf,
          jabatan: listAllParaf.find(s => s.pengguna.id === id).pengguna.jabatan.nama,
          jabatan_id: listAllParaf.find(s => s.pengguna.id === id).pengguna.jabatan.id,
        };
      });
      this.listParaf = filteredParaf.sort(function(a, b){ return a.jabatan_id - b.jabatan_id});
    },

    async archiveSubmit() {
      // const archiveManager = await this.getArchiveManager();
      const variables = {
        id: this.surat.id,
        input: {
          status: "arsip",
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "archived",
                keterangan: "Surat diarsipkan",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.refreshSuratQuery();
        }
      });
    },

    async getArchiveManager() {
      const response = await this.$apollo.query({
        query: FIND,
        where: { column: "ROLE", value: "pengelola_arsip" }
      });
      const data = await response.data;
      return data.pengguna;
    },

    confirmSendMail() {
      this.$root.confirmDialog({
        title: "Kirim Surat",
        message: "Status surat menjadi terkirim dan surat akan diarsipkan",
        acceptTitle: "Iya, Kirim",
        cancelTitle: "Kembali",
        onAccept: this.handleOnSendMail
      });
    },

    async handleOnSendMail() {
      try {
        await this.sendMailSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Surat"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Arsip surat gagal"
        });
      }
    },

    async sendMailSubmit() {
      const variables = {
        id: this.surat.id,
        input: {
          status: "terkirim",
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "send",
                keterangan: "Surat dikirim",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.refreshSuratQuery();
        }
      });
    },

    confirmUnarchive() {
      this.$root.confirmDialog({
        title: "Batalkan Pengarsipan",
        message:
          "Batal Pengarsipan akan membuat surat ini dapat disposisikan kembali ?",
        acceptTitle: "Iya, batalkan",
        cancelTitle: "Kembali",
        onAccept: this.handleOnUnarchive
      });
    },

    async handleOnUnarchive() {
      try {
        await this.unarchiveSubmit();
        this.$vs.notify({
          color: "success",
          title: "Sukses",
          text: "Batalkan pengarsipan surat sukses"
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Gagal",
          text: "Batalkan pengarsipan  surat gagal"
        });
      }
    },

    async unarchiveSubmit() {
      const variables = {
        id: this.surat.id,
        input: {
          status: "draft",
          disposisi: {
            create: [
              {
                ke_pengguna: this.$user.id,
                tipe: "unarchived",
                keterangan: "Batal diarsipkan",
                pengguna_id: this.$user.id
              }
            ]
          }
        }
      };
      await this.$apollo.mutate({
        mutation: UPDATE,
        variables,
        update: () => {
          this.refreshSuratQuery();
        }
      });
    },

    handleAgenda() {
      this.$router.openNewTab({
        name: "agenda-buat",
        query: { surat: this.surat.uuid }
      });
    },

    // Edit Action
    editSurat() {
      const path = this.surat.isInbox
        ? "/surat/ubah/masuk"
        : "/surat/ubah/keluar";

      const suratId = this.surat.isInbox
        ? this.surat.surat_masuk.uuid
        : this.surat.surat_keluar.uuid;

      const full_path = `${path}/${suratId}`;
      this.$router.push({ path: full_path });
    },

    getSuratModified(surat) {
      surat.disposisi = surat.disposisi.map(disposisi => {
        return disposisiModifier(disposisi);
      });
      surat.dokumen = surat.dokumen.map(dokumen => {
        return dokumenModifier(dokumen);
      });
      return suratModifier(surat);
    },

    refreshSuratQuery(interval = 100) {
      setTimeout(() => {
        this.$apollo.queries.surat.skip = false;
        this.$apollo.queries.surat.refetch();
        this.$store.dispatch("globalApp/refetchBadge", true);
      }, interval);
    },

    callbackNomorSurat() {
      console.log("callback surat");
      this.$apollo.queries.surat.refetch();
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
